import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverViewHeight from 'components/cases/common/OverviewHeight/'
import Interview from 'components/cases/nakajitsu/Interview/Interview'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import {
  firstViewItemWhite,
  overviewItem,
  overviewTitle,
  issueSolutionItems,
  caseCTAItem,
  caseDownloadCTAItem,
} from './nakajitsuItems'
import styles from './nakajitsu.module.scss'
import CaseCTA from 'components/cases/common/CaseCTA'
import CaseDownloadCTA from 'components/cases/common/CaseDownloadCTA'
import FooterCTA from 'components/common/FooterCTA'

const Nakajitsu = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverViewHeight
        overviewItem={overviewItem}
        issueSolutionItems={issueSolutionItems}
        overviewTitle={overviewTitle}
      />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <CaseDownloadCTA {...caseDownloadCTAItem} />
      <FooterCTA />
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
    </>
  )
}

export default Nakajitsu
